<script setup lang="ts">
import { useThemeStore } from "@/stores/themeStore";
import { config } from "@/lib/variantConfig";

const themeStore = useThemeStore();
</script>

<template>
  <img
    :src="
      themeStore.theme === 'dark'
        ? '/logo_onboarding_dark.svg'
        : '/logo_onboarding.svg'
    "
    :alt="config.strings.app_name"
  />
</template>
